export default __webpack_public_path__ + "static/media/elina.f7f1bfd2.png";